import * as Cesium from 'cesium';
import * as turf from "@turf/turf";
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import MapUtil from '../utils/mapUtil';
/**
 * 员工图层
 */
export default class WorkerLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.WORKER;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((item,index) =>{
            self.addEntity(item);
        });
    }

    updateEntities(data){
        let self=this;
        self.getEntities().values.forEach((entity)=>{//Todo:删除离线作业者
            if(data.filter(obj=>obj.entityId==Number(entity.id)).length==0){
                self.removeEntityById(entity.id);
            }
        })

        data.map((i,index) =>{
            let item={...i};
            item.longitude=item.x;
            item.latitude=item.y;
            item.layerName=this.layerName;
            item.icon=item.icon||'1';
            item.time=new Date(item.timestamp).toLocaleString();
            if(item.longitude&&item.latitude){
                let entity=self.getEntityById(item.entityId);
                if(entity){
                    let position=Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude)
                    if(item.longitude!=entity.attributes.longitude||item.latitude!=entity.attributes.latitude){
                        entity.position.addSample(Cesium.JulianDate.now(), position);
                        entity.attributes.longitude=item.longitude;
                        entity.attributes.latitude=item.latitude;
                    }
              }else{
                self.addEntity(item);
              }
            }
        });
    }

    addEntity(data){
        if(data.longitude&&data.latitude){
            let position = new Cesium.Cartesian3.fromDegrees(data.longitude,data.latitude)
            const positionProperty = new Cesium.SampledPositionProperty();
            positionProperty.addSample(Cesium.JulianDate.now(), position);
            // Set the interpolation behavior for the entity
            positionProperty.setInterpolationOptions({
                interpolationDegree: 5,
                interpolationAlgorithm: Cesium.LagrangePolynomialApproximation,
            });
            positionProperty.forwardExtrapolationType =Cesium.ExtrapolationType.HOLD;//动画完成后不消失entity
            let entity=new Cesium.Entity({
                position: positionProperty,
                id:data.entityId,
                attributes:{...data},
                //立广告牌
                billboard :{
                    image : require("../../img/map/user"+data.sex+".png"),
                    show : true,
                    width : 26,
                    height : 52,
                    pixelOffset:new Cesium.Cartesian2(0, 0),
                    eyeOffset:new Cesium.Cartesian3(0, 0,data.entityId*-1),
                    scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.5),
                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                    //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//影响移动动画性能，关闭
                },
                label:{
                    text : data.entityName,
                    style:Cesium.LabelStyle.FILL,
                    color :Cesium.Color.fromCssColorString('#fff'),
                    backgroundColor:Cesium.Color.fromCssColorString('#0658f8').withAlpha(0.8),
                    backgroundPadding:new Cesium.Cartesian2(7, 5),
                    outlineWidth:0,
                    font: "14px Helvetica",
                    showBackground : true,
                    pixelOffset:new Cesium.Cartesian2(0, -48),
                    eyeOffset:new Cesium.Cartesian3(0,0,data.entityId*-1),
                    disableDepthTestDistance: Number.POSITIVE_INFINITY,
                    //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//影响移动动画性能，关闭
                },
            })
            this.dataSource.entities.add(entity);
        }
    }


    /**
     * 计算实体的位置矩阵
     * @param entity
     * @param time
     * @returns {*}
     */
   computeModelMatrix(entity, time){
        let position = Cesium.Property.getValueOrUndefined(
            entity.position,
            time,
            new Cesium.Cartesian3()
        );
        if (!Cesium.defined(position)) {
            return undefined;
        }
        let orientation = Cesium.Property.getValueOrUndefined(
            entity.orientation,
            time,
            new Cesium.Quaternion()
        );
        let modelMatrix;
        if (!Cesium.defined(orientation)) {
            modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(
                position,
                undefined,
                new Cesium.Matrix4()
            );
        } else {
            modelMatrix = Cesium.Matrix4.fromRotationTranslation(
                Cesium.Matrix3.fromQuaternion(orientation, new Cesium.Matrix3()),
                position,
                new Cesium.Matrix4()
            );
        }
        return modelMatrix;
    };

    /**
     * 计算实体的当前旋转状态
     * @param entity
     */
    getEntityHPR(entity){
        let self=this;
        return Cesium.Transforms.fixedFrameToHeadingPitchRoll(
            self.computeModelMatrix(
                entity,
                viewer.clock.currentTime || Cesium.JulianDate.now()
            )
        );
    }
};
